import React, { useState, useEffect } from 'react';
import CONSTANTS from '../utils/constants';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Payment() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [settings, setSettings] = useState({
    price: false,
    card: false,
    online: false,
    coment: false
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await fetch(`${CONSTANTS.baseRoute}/settings/admin`);
      if (!response.ok) {
        throw new Error(t('payment.fetchError'));
      }

      const data = await response.json();

      let row = null;
      if (data?.settings) {
        if (Array.isArray(data.settings) && data.settings.length > 0) {
          row = data.settings[0];
        } else if (typeof data.settings === 'object') {
          row = data.settings;
        }
      }

      if (row) {
        setSettings({
          price: Boolean(row.price),
          card: Boolean(row.card),
          online: Boolean(row.online),
          coment: Boolean(row.coment)
        });
      } else {
        setSettings({ price: false, card: false, online: false, coment: false });
      }
    } catch (err) {
      setError(err.message);
      setSettings({ price: false, card: false, online: false, coment: false });
    } finally {
      setLoading(false);
    }
  };

  const updateSetting = async (key, value) => {
    try {
      const response = await fetch(`${CONSTANTS.baseRoute}/settings`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ [key]: value })
      });

      if (!response.ok) {
        throw new Error(t('payment.updateError'));
      }

      setSettings(prev => ({ ...prev, [key]: value }));

      // sync
      setTimeout(fetchSettings, 100);
    } catch (err) {
      setError(err.message);
      fetchSettings();
    }
  };

  const handleToggle = (key) => {
    updateSetting(key, !settings[key]);
  };

  /* ===================== LOADING ===================== */
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: 200 }}>
        <div className="spinner-border" role="status">
          <span className="visually-hidden">{t('loading')}</span>
        </div>
      </div>
    );
  }

  /* ===================== ERROR ===================== */
  if (error) {
    return (
      <div className="alert alert-danger">
        {error}
        <button className="btn btn-sm btn-outline-danger ms-2" onClick={fetchSettings}>
          {t('retry')}
        </button>
      </div>
    );
  }

  /* ===================== UI ===================== */
  return (
    <div className="admin-main ps-2 pe-3 py-2">
      <div className="d-flex align-items-center justify-content-between mb-2">
        <div className="d-flex gap-2 align-items-center">
          <button className="btn admin-icon-btn" onClick={() => navigate(-1)}>
            <i className="bi bi-chevron-left"></i>
          </button>
          <button className="btn admin-icon-btn" onClick={() => navigate(+1)}>
            <i className="bi bi-chevron-right"></i>
          </button>
          <h5 className="fw-bold">{t('payment.title')}</h5>
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card">
            <div className="card-header">
              <h5 className="mb-0">{t('payment.title')}</h5>
            </div>

            <div className="card-body">
              {/* CASH */}
              <div className="form-check form-switch mb-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={settings.price}
                  onChange={() => handleToggle('price')}
                />
                <label className="form-check-label">
                  <strong>{t('payment.cash')}</strong>
                </label>
              </div>

              <hr />

              {/* CARD */}
              <div className="form-check form-switch mb-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={settings.card}
                  onChange={() => handleToggle('card')}
                />
                <label className="form-check-label">
                  <strong>{t('payment.card')}</strong>
                </label>
              </div>

              <hr />

              {/* ONLINE */}
              <div className="form-check form-switch mb-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={settings.online}
                  onChange={() => handleToggle('online')}
                />
                <label className="form-check-label">
                  <strong>{t('payment.online')}</strong>
                </label>
              </div>

              {/* <hr /> */}

              {/* COMMENT */}
              {/* <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={settings.coment}
                  onChange={() => handleToggle('coment')}
                />
                <label className="form-check-label">
                  <strong>{t('payment.comments')}</strong>
                </label>
              </div> */}
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}
